import Login from "../features/Auth/Components/Login";

function LoginPage() {
    return(
        <div>
            <Login/>
            </div>
    )
}
export default LoginPage;